
import { StepLocationModel } from "../StepLocationModel";
import { Conduit, Graft, Hemisphere } from "./TriggerClasses";



export enum CarotidVessel
{
    RICA = "RICA",
    LICA = "LICA",
    RCCA = "RCCA",
    LCCA = "LCCA"
}

export enum CarotidProcedures
{
    CONVENTIONAL = "Conventional",
    EVERSION = "Eversion",
    INTERPOSITION = "Interposition"
}

export enum HemisphereLocation
{
    Right = "Right",
    Left = "Left"
}

export enum PatchMaterial
{
  Bovine = "Bovine",
    Synthetic = "Synthetic",
    Vein = "Vein",
    None = "None"
}

export enum PeripheralGraftPoints
{
    // SA = "SA",
    // AA = "AA",
    // ASCAORTA = "ASCAORTA",
    // ABAORTA = "ABAORTA",
    CIA = "CIA",
    EIA = "EIA",
    CFA = "CFA",
    SFA = "SFA",
    PFA = "PFA",
    POP_ATK = "POP_ATK",
    POP_BTK = "POP_BTK",
    ATA = "ATA",
    PTA = "PTA",
    PA = "PA"

}

export enum PeripheralGraftMaterial
{
  VEIN="VEIN",
    BIOGRAFT="BIOGRAFT",
    PROSTHETIC="PROSTHETIC",
    CUSTOM="CUSTOM"
}

export enum PeripheralType
{
  BYPASS = "BYPASS",
  OTHER = "OTHER"
}

export enum AVAccessType
{
    SIDEATOENDV = "Side A to End V",
    ENDATOENDV = "End A to End V",
    ENDATOSIDEV = "End A to Side V",
    SIDEATOSIDEV = "Side A to Side V",
    PROTHESTICLOOP = "Prosethic Loop"
}

export enum AVAccessVein
{
    CEPHALIC = "Cephalic",
    BASILIC = "Basilic",
    VEINBRACHIAL = "Brachial",
    MEDIANCUBITAL = "Median Cubital",
    AXILLARY = "Axillary"
}

export enum AVAccessArtery
{
    ULNAR = "Ulnar",
    RADIAL = "Radial",
    ARTERYBRACHIAL = "Brachial"
}

export class VascularGraft extends Graft{

    CarotidVessels:  CarotidVessel[] = [];
    GraftPoint?: PeripheralGraftPoints;
    Material?: PeripheralGraftMaterial;
    hemisphere?: Hemisphere;
    Vein?: AVAccessVein;
    Artery?: AVAccessArtery; 
    AVConfig?: AVAccessType;
    ProcedureType?: CarotidProcedures | PeripheralType;
    CarotidPatchMaterial?: PatchMaterial; 
}

export class VascularHelpers {

    public static graftFound: VascularGraft;
    public static graftRemoved: VascularGraft;

    public static indexOfLocation(timeStepIndex: number, timeStepName: string, value: string, locations?: StepLocationModel[]): number
    {
        let indexToReturn = -1;
        if (!locations)
          return -1;
        for (let index = 0; index < locations.length; index++) {
          const element = locations[index];
          if (element.name === value && timeStepIndex === element.timeStepIndex)
          {
            indexToReturn = index;
          }
        }
        return indexToReturn;
    } 


    public static addLocationAndRemoveElsewhere(timeStepIndex: number, timeStepName: string, value: string, locations?: StepLocationModel[]):  StepLocationModel[]
    {
        let indexFound = this.indexOfLocation(timeStepIndex, timeStepName, value, locations);

        //First we remove the measurement from every location
        locations = [];
        let locationToAdd: StepLocationModel = {
            timeStepIndex: timeStepIndex,
            name: value,
            timeStepName: timeStepName
          }
          //Then we add it in again in the new location if it wasn't in the same place before
          if (locations && indexFound === -1)
            locations.push(locationToAdd);
        return locations;
    }
    public static firstIndexOfVessel(value: string, locations: StepLocationModel[]): number
    {
        let indexToReturn = -1;
        if (!locations)
          return -1;
        for (let index = 0; index < locations.length; index++) {
          const element = locations[index];
          if (element.name === value)
          {
            indexToReturn = index;
          }
        }
        return indexToReturn;
    } 


      public static addRemoveLocation(timeStepIndex: number, timeStepName: string, value: string, locations?: StepLocationModel[]):  StepLocationModel[]
    {
      

        let indexFound = this.indexOfLocation(timeStepIndex, timeStepName, value, locations);
        if (!locations)
          locations = [];
        if (indexFound === -1)
        {
          let locationToAdd: StepLocationModel = {
            timeStepIndex: timeStepIndex,
            timeStepName: timeStepName,
            name: value
          }
          if (locations)
           locations.push(locationToAdd);
        }else
        {
          if (locations)
            locations.splice(indexFound, 1);
        }
        if (locations)
        return locations;
      else
      return [];
    } 

    public static removeVesselFromLocations(value: string, locations?: StepLocationModel[]):  StepLocationModel[]
    {
       if (!locations)
          locations = [];
      let indexFound = this.firstIndexOfVessel(value, locations);
        if (indexFound !== -1)
        {
          if (locations)
            locations.splice(indexFound, 1);
        }
        return locations;
    } 


    public static createGraftsFromLabels(labelsIn: string[]): Graft[]
    {
        let graftsOut: Graft[] = [];
        if (labelsIn.length > 0)
        {
        let currentGraft : VascularGraft = Graft.getBlankGraft(false, undefined, "PeripheralGraft") as VascularGraft;
        currentGraft.Material = PeripheralGraftMaterial.VEIN;
        currentGraft.type = "PeripheralGraft";
        let startingIndex = 0;
        while (startingIndex < labelsIn.length && Object.keys(PeripheralGraftPoints).indexOf(labelsIn[startingIndex]) === -1) {
          startingIndex++;
        }
        if (startingIndex < labelsIn.length)
        {
            currentGraft.title = labelsIn[startingIndex];
            currentGraft.GraftPoint = labelsIn[startingIndex] as PeripheralGraftPoints;
            currentGraft.sequential = true;
            for (let index = startingIndex+1; index < labelsIn.length; index++) {
              let newGraft : VascularGraft = Graft.getBlankGraft(false, undefined, "PeripheralGraft") as VascularGraft;
              if (Object.keys(PeripheralGraftPoints).indexOf(labelsIn[index]) > -1)
                {
              newGraft.Material = PeripheralGraftMaterial.VEIN;
              newGraft.title = labelsIn[index];
              newGraft.GraftPoint = labelsIn[index] as PeripheralGraftPoints;
              newGraft.type = "PeripheralGraft";
            this.addToBottom(currentGraft as VascularGraft, newGraft as VascularGraft);
                }
            }
            graftsOut.push(currentGraft);
        }
      }
      return graftsOut;
    }

public static recursePointsNoHemisphere(currentGraft: VascularGraft, pointToCheckFor: PeripheralGraftPoints, remove?: boolean, ignoreDraft?: boolean): boolean
    {
     
        if (!remove && currentGraft.GraftPoint === pointToCheckFor && (!ignoreDraft || !currentGraft.draft))
        {
            this.graftFound = currentGraft;
          return true;
        }
        if (currentGraft.targets && currentGraft.targets.length > 0)
    {
      let isFound = false;
      for (let index = 0; index < currentGraft.targets.length; index++) {
        const element = currentGraft.targets[index] as VascularGraft;
    
        if (remove)
          {
            isFound = this.recursePointsNoHemisphere(element, pointToCheckFor, remove, ignoreDraft);
            if (!isFound && element.GraftPoint === pointToCheckFor)
            {
              this.graftRemoved = element;
                     //if the target was found, it means it has been removed and so we need to set it's parent as the active one.
                     //HAAKON???? parent cannot be set to parent, should be set to the previous last graft.
                       //Set the previous to the last graft clicked before it changes.
              
                       //If the previous item selected hasns't been set or it doesn't exist anymore then set the parent graft as the last graft.
              
    
              //Take the parent as the next item in the default focus tree.
              //this.previousGraftClicked = currentGraft;
              currentGraft.targets.splice(index, 1);
              isFound = true;
              
            }
          }
          else{
            isFound = this.recursePointsNoHemisphere(element as VascularGraft, pointToCheckFor, false, ignoreDraft);
          }
          if (isFound)
          {
            
            return isFound;
          }

      }
    
     
    }
    if (remove && currentGraft.GraftPoint === pointToCheckFor && (!ignoreDraft || !currentGraft.draft))
    {
        this.graftFound = currentGraft;
        // currentGraft.GraftPoint = null;
        // currentGraft.hemisphere = null;
        // currentGraft.Title = null;
          return true;
    }
    return false;
    }

    public static recursePoints(currentGraft: VascularGraft, pointToCheckFor: PeripheralGraftPoints, hemisphere: Hemisphere, remove?: boolean, ignoreDraft?: boolean): boolean
    {
     
        if (!remove && currentGraft.GraftPoint === pointToCheckFor && currentGraft.hemisphere === hemisphere && (!ignoreDraft || !currentGraft.draft))
        {
            this.graftFound = currentGraft;
          return true;
        }
        if (currentGraft.targets && currentGraft.targets.length > 0)
    {
      let isFound = false;
      for (let index = 0; index < currentGraft.targets.length; index++) {
        const element = currentGraft.targets[index] as VascularGraft;
    
        if (remove)
          {
            isFound = this.recursePoints(element, pointToCheckFor, hemisphere, remove, ignoreDraft);
            if (!isFound && element.GraftPoint === pointToCheckFor && element.hemisphere === hemisphere)
            {
              this.graftRemoved = element;
                     //if the target was found, it means it has been removed and so we need to set it's parent as the active one.
                     //HAAKON???? parent cannot be set to parent, should be set to the previous last graft.
                       //Set the previous to the last graft clicked before it changes.
              
                       //If the previous item selected hasns't been set or it doesn't exist anymore then set the parent graft as the last graft.
              
    
              //Take the parent as the next item in the default focus tree.
              //this.previousGraftClicked = currentGraft;
              currentGraft.targets.splice(index, 1);
                
              isFound = true;
              
            }
          }
          else{
            isFound = this.recursePoints(element as VascularGraft, pointToCheckFor, hemisphere, false, ignoreDraft);
          }
          if (isFound)
          {
            
            return isFound;
          }

      }
    
     
    }
    if (remove && currentGraft.GraftPoint === pointToCheckFor && currentGraft.hemisphere === hemisphere && (!ignoreDraft || !currentGraft.draft))
    {
        this.graftFound = currentGraft;
        // currentGraft.GraftPoint = null;
        // currentGraft.hemisphere = null;
        // currentGraft.Title = null;
          return true;
    }
    return false;
    }
    public static addToBottom(currentGraft: VascularGraft, graftToAdd: VascularGraft, ignoreTop: boolean = false): boolean
    {
     
        if (!currentGraft.GraftPoint && !ignoreTop)
        {
            //currentGraft.BlankNewItem = false;
            currentGraft.title = graftToAdd.title;
            currentGraft.GraftPoint = graftToAdd.GraftPoint;
            currentGraft.type = "PeripheralGraft";
            currentGraft.hemisphere = graftToAdd.hemisphere;
            return true;
        }
        if (currentGraft.targets && currentGraft.targets.length > 0)
        {
            for (let index = 0; index < currentGraft.targets.length; index++) {
                const element = currentGraft.targets[index] as VascularGraft;
                if (this.addToBottom(element, graftToAdd, ignoreTop))
                    break;
            }
        }else
        {
            if (!currentGraft.targets)
                currentGraft.targets = [];
            currentGraft.targets.push(graftToAdd);
            return true;
        }
        return false;
    }
    public static recurseGraftForMaterials(currentGraft: VascularGraft, material: PeripheralGraftMaterial): boolean
    {
        if (currentGraft.Material === material)
            return true;
        if (currentGraft.targets && currentGraft.targets.length > 0)
        {
            for (let index = 0; index < currentGraft.targets.length; index++) {
                const element = currentGraft.targets[index] as VascularGraft;
                if (this.recurseGraftForMaterials(element, material))
                    return true;
            }
        }
        return false;
    }
    public static recurseGraftSetMaterials(currentGraft: VascularGraft, material: PeripheralGraftMaterial)
    {
        currentGraft.Material = material;
        if (currentGraft.targets && currentGraft.targets.length > 0)
        {
            for (let index = 0; index < currentGraft.targets.length; index++) {
                const element = currentGraft.targets[index] as VascularGraft;
                this.recurseGraftForMaterials(element, material);
            }
        }
    }
    public static recurseVein(currentGraft: VascularGraft, pointToCheckFor: AVAccessVein, remove?: boolean, ignoreDraft?: boolean): boolean
    {
     
        if (!remove && currentGraft.Vein === pointToCheckFor  && (!ignoreDraft || !currentGraft.draft))
        {
            this.graftFound = currentGraft;
          return true;
        }
        if (currentGraft.targets && currentGraft.targets.length > 0)
    {
      let isFound = false;
      for (let index = 0; index < currentGraft.targets.length; index++) {
        const element = currentGraft.targets[index] as VascularGraft;
    
        if (remove)
          {
            isFound = this.recurseVein(element, pointToCheckFor, remove, ignoreDraft);
            if (!isFound && element.Vein === pointToCheckFor)
            {
              this.graftRemoved = element;
                     //if the target was found, it means it has been removed and so we need to set it's parent as the active one.
                     //HAAKON???? parent cannot be set to parent, should be set to the previous last graft.
                       //Set the previous to the last graft clicked before it changes.
              
                       //If the previous item selected hasns't been set or it doesn't exist anymore then set the parent graft as the last graft.
              
    
              //Take the parent as the next item in the default focus tree.
              //this.previousGraftClicked = currentGraft;
              currentGraft.targets.splice(index, 1);
                
              isFound = true;
              
            }
          }
          else{
            isFound = this.recurseVein(element as VascularGraft, pointToCheckFor, false, ignoreDraft);
          }
          if (isFound)
          {
            
            return isFound;
          }

      }
    
     
    }
    if (remove && currentGraft.Vein === pointToCheckFor && (!ignoreDraft || !currentGraft.draft))
    {
        this.graftFound = currentGraft;
        // currentGraft.GraftPoint = null;
        // currentGraft.hemisphere = null;
        // currentGraft.Title = null;
          return true;
    }
    return false;
    }
    public static recurseArtery(currentGraft: VascularGraft, pointToCheckFor: AVAccessArtery, remove?: boolean, ignoreDraft?: boolean): boolean
    {
     
        if (!remove && currentGraft.Artery === pointToCheckFor  && (!ignoreDraft || !currentGraft.draft))
        {
            this.graftFound = currentGraft;
          return true;
        }
        if (currentGraft.targets && currentGraft.targets.length > 0)
    {
      let isFound = false;
      for (let index = 0; index < currentGraft.targets.length; index++) {
        const element = currentGraft.targets[index] as VascularGraft;
    
        if (remove)
          {
            isFound = this.recurseArtery(element, pointToCheckFor, remove, ignoreDraft);
            if (!isFound && element.Artery === pointToCheckFor)
            {
              this.graftRemoved = element;
                     //if the target was found, it means it has been removed and so we need to set it's parent as the active one.
                     //HAAKON???? parent cannot be set to parent, should be set to the previous last graft.
                       //Set the previous to the last graft clicked before it changes.
              
                       //If the previous item selected hasns't been set or it doesn't exist anymore then set the parent graft as the last graft.
              
    
              //Take the parent as the next item in the default focus tree.
              //this.previousGraftClicked = currentGraft;
              currentGraft.targets.splice(index, 1);
                
              isFound = true;
              
            }
          }
          else{
            isFound = this.recurseArtery(element as VascularGraft, pointToCheckFor, false, ignoreDraft);
          }
          if (isFound)
          {
            
            return isFound;
          }

      }
    
     
    }
    if (remove && currentGraft.Artery === pointToCheckFor && (!ignoreDraft || !currentGraft.draft))
    {
        this.graftFound = currentGraft;
        // currentGraft.GraftPoint = null;
        // currentGraft.hemisphere = null;
        // currentGraft.Title = null;
          return true;
    }
    return false;
    }
    public static toggleVein(currentGraft: VascularGraft, veinToAdd: AVAccessVein, hemisphere: Hemisphere): boolean
    {
        if (currentGraft.Vein === veinToAdd)
        {
            //currentGraft.BlankNewItem = false;
            currentGraft.title = "";
            currentGraft.Vein = undefined;
            currentGraft.type = "AVVein";
            currentGraft.sequential = true;
            currentGraft.hemisphere = hemisphere;
            return false;
        }
        else
        {
            //currentGraft.BlankNewItem = false;
            currentGraft.title = veinToAdd;
            currentGraft.sequential = true;
            currentGraft.Vein = veinToAdd;
            currentGraft.type = "AVVein";
            //Make it blue
            currentGraft.conduit = Conduit.SVG;
            currentGraft.hemisphere = hemisphere;
            return true;
        }
        
    }
    public static toggleArtery(currentGraft: VascularGraft, veinToAdd: AVAccessArtery, hemisphere: Hemisphere): boolean
    {
        if (currentGraft.Artery === veinToAdd)
        {
            //currentGraft.BlankNewItem = false;
            currentGraft.title = "";
            currentGraft.Artery = undefined;
            currentGraft.type = "AVVein";
            currentGraft.sequential = true;
            currentGraft.hemisphere = hemisphere;
            return false;
        }
        else
        {
            //currentGraft.BlankNewItem = false;
            currentGraft.title = veinToAdd;
            currentGraft.sequential = true;
            currentGraft.Artery = veinToAdd;
            currentGraft.type = "AVVein";
            //Make it blue
            currentGraft.conduit = Conduit.LITA;
            currentGraft.hemisphere = hemisphere;
            return true;
        }
        
    }
    
   

}
